/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { CSSProperties, useCallback, useEffect, useMemo, useRef, useState } from "react";
import cn from "classnames";
import sass from "./input.module.sass";
import DropSelect from "components-new/DropSelect";
import Tooltip from "components-new/Tooltip";
import { ReactComponent as Empty } from "images/empty-tray-svgrepo-com.svg";
import { ReactComponent as Arrow } from "images/FiltrationTickIcon.svg";
import { ReactComponent as Load } from "images/load.svg";
import { ReactComponent as Search } from "images/SearchIcon.svg";
import useDebounce from "hooks/useDebounce";
import { isEmpty } from "helpers";
import { usePaginationWithIntersection } from "hooks/usePaginationWithIntersection";

interface IOptions {
	id: number | string | null;

	[key: string]: any;
}
//TODO: Нужно добавить описание
export type FieldOptions = string | string[];

interface BaseProps
	extends Omit<React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>, "onSelect" & "type" & "required"> {}

interface IInput extends BaseProps {
	remote?: { link: string; initialParams: { [key: string]: any }; isStringList?: boolean };
	required?: boolean;
	label?: string;
	search?: boolean;
	options?: IOptions[];
	field?: FieldOptions;
	subTitle?: FieldOptions;
	name?: string;
	filter?: boolean;
	onSelect?: (obj: any) => void;
	currentValue?: { [key: string]: any };
	value?: string;
	emptySearch?:boolean
	load?: boolean;
	type?: "select" | "input" | "phone";
	multiline?: boolean;
	placeholder?: string;
	warning?: string;
	searchIcon?: boolean;
	emptyOptions?: boolean;
	wordWrap?: "wrap" | "nowrap";
	isCreated?: boolean;
}
/*вы можете сохранить введенное значение*/
/**
 * Универсальный компонент, изначально задумывался как простой инпут,
 * теперь есть добавление иконки поиска и иконка флага, в первом случае он так и остается инпутом, во втором
 * подключаются прослушиватели ввода и маска ввода
 * Так же компонент работает как селект
 * @constructor
 */
const InputTemp: React.FC<IInput & { error?: boolean; errorText?: string }> = ({
	name = "",
	isCreated = false,
	wordWrap = "nowrap",
	subTitle = [],
	emptyOptions = true,
	searchIcon = false,
	multiline = false,
	value,
	currentValue,
	onSelect,
	load = false,
	filter = false,
	remote = {},
	options,
	error = false,
	placeholder = "",
	onChange,
	required = false,
	errorText,
	type = "input",
	field = [],
	className,
	search = false,
	label,
	readOnly = false,
	warning,
																																								 emptySearch = false,
																																								 onFocus,
	onBlur,
	...rest
}) => {
	/* if type phone logic */
	const getInputNumbersValue = function (input: any) {
		return input.value.replace(/\D/g, "");
	};

	const [searchRemote, setSearchRemote] = useState("");

	const debounced = useDebounce(searchRemote, 400);

	const lastTarget = useRef<HTMLDivElement | null>(null);

	const lastSearchTarget = useRef<HTMLDivElement | null>(null);

	const [localOptions, setLocalOptions] = useState<any[]>([]);

	const [searchedOptions, setSearchedOptions] = useState<any[]>([]);

	const [params, setParams] = useState<{ [key: string]: any }>(remote?.initialParams || {});

	const [paramsSearched, setParamsSearched] = useState<{ [key: string]: any }>(remote?.initialParams || {});

	const isFirstLoad = useRef(true);

	const pageUp = useCallback(
		(prevState: typeof params) => {
			return { ...prevState, ...(prevState.part ? { part: prevState.part + 1 } : { page: prevState.page + 1 }) };
			//eslint-disable-next-line
		},[remote],
	);

	const then = useCallback(
		(data: any[]) => {
			const noPage = params.page || params.part;
			const newData = remote?.isStringList ? data.map((name: string, id: number) => ({ id: id + 1, name })) : data;
			if (!noPage) {
				setIsFinally(true);
			}

			if (!isEmpty(remote)) {
				const page = params.page ? params.page : params.count;
				if (page === 1) {
					if (data.length) {
						if (data.length < params.num) {
							setIsFinally(true);
						} else {
							noPage && setParams(pageUp);
						}
					} else {
						setIsFinally(true);
					}
					setLocalOptions(newData);
				} else {
					if (data.length) {
						if (!(data.length < params.num)) {
							setParams(pageUp);
						} else {
							setIsFinally(true);
						}
						setLocalOptions((prevState) => [...prevState, ...newData]);
					} else {
						setIsFinally(true);
					}
				}
			}
			//eslint-disable-next-line
		},[params, remote],
	);
	const thenSearch = useCallback(
		(data: any[]) => {
			const noPage = paramsSearched.page || paramsSearched.part;
			const newData = remote?.isStringList ? data.map((name: string, id: number) => ({ id: id + 1, name })) : data;
			if (!noPage) {
				setFinallySearched(true);
			}

			if (!isEmpty(remote)) {
				const page = paramsSearched.page ? paramsSearched.page : paramsSearched.count;
				if (page) {
					if (page === 1) {
						if (data.length) {
							if (data.length < paramsSearched.num) {
								setFinallySearched(true);
							} else {
								noPage && setParamsSearched(pageUp);
							}
						} else {
							setFinallySearched(true);
						}
						setSearchedOptions(newData);
					} else {
						if (data.length) {
							if (!(data.length < paramsSearched.num)) {
								setParamsSearched(pageUp);
							} else {
								setFinallySearched(true);
							}
							setSearchedOptions((prevState) => [...prevState, ...newData]);
						} else {
							setFinallySearched(true);
						}
					}
				} else {
					setSearchedOptions(data);
				}
			}
			//eslint-disable-next-line
		},[paramsSearched, remote],
	);
	const onPhonePaste = function (e: any) {
		let input = e.target,
			inputNumbersValue = getInputNumbersValue(input);
		// @ts-ignore
		let pasted = e.clipboardData || window.clipboardData;
		if (pasted) {
			let pastedText = pasted.getData("Text");
			if (/\D/g.test(pastedText)) {
				input.value = inputNumbersValue;
				if (onChange) {
					onChange(e);
				}
			}
		}
	};

	const onPhoneKeyDown = function (e: any) {
		let inputValue = e.target.value.replace(/\D/g, "");
		if (e.keyCode === 8 && inputValue.length === 1) {
			e.target.value = "";
		}
	};

	const onPhoneInput = function (e: any) {
		let input = e.target,
			inputNumbersValue = getInputNumbersValue(input),
			selectionStart = input.selectionStart,
			formattedInputValue = "";

		if (!inputNumbersValue) {
			return (input.value = "");
		}

		if (input.value.length !== selectionStart) {
			if (e.data && /\D/g.test(e.data)) {
				input.value = inputNumbersValue;
			}
			return;
		}

		if (["7", "8", "9", "+"].indexOf(inputNumbersValue[0]) > -1) {
			if (inputNumbersValue[0] === "9") inputNumbersValue = "7" + inputNumbersValue;
			let firstSymbols = inputNumbersValue[0] === "8" ? "8" : inputNumbersValue[0] === "7" ? "+7" : "";
			formattedInputValue = input.value = firstSymbols + " ";
			if (inputNumbersValue.length > 1) {
				formattedInputValue += "(" + inputNumbersValue.substring(1, 4);
			}
			if (inputNumbersValue.length >= 5) {
				formattedInputValue += ") " + inputNumbersValue.substring(4, 7);
			}
			if (inputNumbersValue.length >= 8) {
				formattedInputValue += "-" + inputNumbersValue.substring(7, 9);
			}
			if (inputNumbersValue.length >= 10) {
				formattedInputValue += "-" + inputNumbersValue.substring(9, 11);
			}
		} else {
			formattedInputValue = "+" + inputNumbersValue.substring(0, 11);
		}
		input.value = formattedInputValue;
	};

	const onPhoneKeyUp = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		// onPhoneKeyDown(e);
		onPhoneInput(e);
		// onPhonePaste(e);
		if (onChange) {
			onChange(e);
		}
	};
	/* end type phone logic */

	const ref = useRef<HTMLDivElement>(null);
	const [active, setActive] = useState(false);

	const filterOptions = useMemo(() => {
		if (options) {
			let newOptions: typeof options;
			if (filter && value) {
				// if (currentValue[name]) {
				newOptions = [...options].filter((_) => {
					let renderName =
						typeof field === "object"
							? field.reduce((acc, some) => acc + `${_[some]} `, "").replace(/\s$/, "")
							: _[field];
					return renderName.toLowerCase().includes(value.toLowerCase());
				});
				return newOptions;
				// }
			}
		}
		return options || [];
		//eslint-disable-next-line
	}, [filter, options, value]);

	const whiteSpace = useMemo(() => {
		return wordWrap === "nowrap" ? { whiteSpace: "nowrap" } : {};
	}, [wordWrap]);

	const renderList = useMemo(() => {
		if (options || localOptions.length) {
			if (field) {
				const renderedOptions = isEmpty(remote) ? options : localOptions;
				return renderedOptions!.map((option, index) => {
					let titles = "";

					if (subTitle.length) {
						titles =
							typeof subTitle === "object"
								? subTitle.reduce((acc, some) => acc + `${option[some]} `, "").replace(/\s$/, "")
								: option[subTitle];
					}
					let renderName =
						typeof field === "object"
							? field.reduce((acc, some) => acc + `${option[some]} `, "").replace(/\s$/, "")
							: option[field];
					return (
						<Tooltip
							key={index}
							show={wordWrap === "nowrap"}
							menu={<div className={sass.tooltip}>{renderName}</div>}
							delay={1000}>
							<div
								style={whiteSpace as CSSProperties}
								key={index}
								className={cn(sass.item, currentValue && option.id === currentValue.id && sass.item_select)}
								onClick={() => {
									if (onSelect) {
										onSelect(option);
										setActive(false);
									}
								}}>
								{!!subTitle.length && <span>{titles}</span>}
								{renderName}
							</div>
						</Tooltip>
					);
				});
			}
		} else {
			return [];
		}
		//eslint-disable-next-line
	}, [field, options, currentValue, localOptions, remote]);

	const searchedList = useMemo(() => {
		let result: any[] = searchedOptions;
		if (filter && isEmpty(remote)) {
			result = filterOptions as any;
		} else {
			if (field || subTitle) {
				result = searchedOptions;
			}
		}
		return result.length
			? result!.map((item, index) => {
					let titles = "";

					if (subTitle.length) {
						titles =
							typeof subTitle === "object"
								? subTitle.reduce((acc, some) => acc + `${item[some]} `, "").replace(/\s$/, "")
								: item[subTitle];
					}
					let renderName =
						typeof field === "object"
							? field.reduce((acc, some) => acc + `${item[some]} `, "").replace(/\s$/, "")
							: item[field];
					return (
						<Tooltip
							key={index}
							show={wordWrap === "nowrap"}
							menu={<div className={sass.tooltip}>{renderName}</div>}
							delay={1000}>
							<div
								style={whiteSpace as CSSProperties}
								key={index}
								className={cn(sass.item, currentValue && item.id === currentValue.id && sass.item_select)}
								onClick={() => {
									if (onSelect) {
										onSelect(item);
										setActive(false);
									}
								}}>
								{!!subTitle.length && <span>{titles}</span>}
								{renderName}
							</div>
						</Tooltip>
					);
			  })
			: [];
		//eslint-disable-next-line
	}, [field, currentValue, searchedOptions, remote]);

	useEffect(() => {
		if (remote && remote.initialParams && isFirstLoad.current) {
			setParams(remote.initialParams);
		}
	}, [remote]);

	useEffect(() => {
		setSearchRemote(value || "");
	}, [value]);

	// useEffect(() => {
	// 	if (debounced && !isEmpty(remote) && !isFirstLoad.current) {
	// 		fetchSearchedOptions(debounced);
	// 	} else {
	// 		setSearchedOptions([]);
	// 	}
	// }, [debounced]);

	// const fetchSearchedOptions = useCallback(
	// 	(query: string) => {
	// 		if (isEmpty(remote)) return;
	// 		$api.get(remote.link!, { params: { ...remote.initialParams, query } }).then(({ data }) => {
	// 			setSearchedOptions(remote.isStringList ? data.map((name: string, id: number) => ({ id: id + 1, name })) : data);
	// 		});
	// 	},
	// 	[remote],
	// );

	useEffect(() => {
		if (isFirstLoad.current && !isEmpty(remote)) isFirstLoad.current = false;
	}, [remote, params]);

	const { setIsFinally } = usePaginationWithIntersection({
		link: remote?.link || "",
		ref: { current: lastTarget.current?.parentNode },
		dependencies: [!isEmpty(remote), !isFirstLoad.current, ref.current],
		lastTarget,
		params,
		then,
	});

	useEffect(() => {
		if (debounced) {
			setParamsSearched({ ...remote.initialParams, query: debounced });
			setFinallySearched(false);
			setSearchFetch(true);
			if (lastTarget.current?.parentNode)
				lastTarget.current?.parentNode.firstElementChild?.scrollIntoView({ block: "start", behavior: "smooth" });
		}
		//eslint-disable-next-line
	}, [debounced]);
	const { setIsFinally: setFinallySearched, setFetch: setSearchFetch } = usePaginationWithIntersection({
		link: remote?.link || "",
		ref: { current: lastTarget.current?.parentNode },
		dependencies: [!isEmpty(remote), !isFirstLoad.current, ref.current, debounced],
		lastTarget: lastSearchTarget,
		params: { ...paramsSearched },
		then: thenSearch,
	});
	return (
		<>
			<div ref={ref} className={cn(sass.wrapper, className)}>
				{warning && (
					<span className={cn(sass.warning, {[sass["warning-error"]]: error || errorText})}>{warning}</span>
				)}
				{multiline ? (
					<textarea
						value={value}
						onChange={(e) => {
							onChange && onChange(e);
						}}
						className={cn({
							[sass.select]: type === "select",
							[sass.error]: error || errorText,
						})}
						readOnly={readOnly ? readOnly : type === "select" && true}
						name={name}
						autoComplete={"off"}
						placeholder={placeholder}
						required={required}
						onFocus={(e) => {
							if (onFocus) onFocus(e);
							(renderList?.length || searchedList?.length) && setActive(true);
						}}
						onBlur={() => {
							setTimeout(() => setActive(false), 180);
						}}
						{...rest}
					/>
				) : (
					<input
						value={value}
						className={cn({
							[sass.select]: type === "select",
							[sass.inputSearch]: searchIcon,
							[sass.phone]: type === "phone",
							[sass.error]: error || errorText,
						})}
						readOnly={readOnly ? readOnly : type === "select" && true}
						name={name}
						required={required}
						onPaste={(e) => {
							if (type === "phone") {
								onPhonePaste(e);
							}
						}}
						onKeyDown={(e) => {
							if (type === "phone") {
								onPhoneKeyDown(e);
							}
						}}
						onChange={type === "phone" ? onPhoneKeyUp : onChange}
						autoComplete={"off"}
						placeholder={placeholder}
						onFocus={(e) => {
							if (onFocus) onFocus(e);
							(renderList?.length || searchedList?.length) && setActive(true);
						}}
						onBlur={(e) => {
							if (onBlur) onBlur(e);
							setTimeout(() => setActive(false), 180);
						}}
						{...rest}
					/>
				)}
				{searchIcon && <Search className={label ? sass.search : sass.searchWithLabel}/>}

				{(error || errorText || label) && (
					<div className={sass.caption}>
						{label && (
							<span className={cn(error || errorText ? sass.labelError : sass.label)}>
								{label}
								{required && <span className={sass.required}> *</span>}
							</span>
						)}
						{errorText && <span className={sass["error-input-title"]}>{errorText || errorText}</span>}
					</div>
				)}
				{(type === "select" || options?.length || onSelect) && (
					<Arrow
						onClick={() => setActive((prevState) => !prevState)}
						className={cn(sass.arrow, sass[`arrow-${active}`])}
					/>
				)}
				{type === "phone" && (
					<svg
						className={label ? sass.phoneIcon : sass.phoneIconWithLabel}
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path d="M0 7.8125H20V12.1875H0V7.8125Z" fill="#1B75BB"/>
						<path
							d="M16.875 3.125H3.125C1.05406 3.125 0 4.66406 0 6.5625V7.8125H20V6.5625C20 4.66406 18.9459 3.125 16.875 3.125Z"
							fill="#E6E7E8"
						/>
						<path
							d="M0 13.4375C0 15.3359 1.05406 16.875 3.125 16.875H16.875C18.9459 16.875 20 15.3359 20 13.4375V12.1875H0V13.4375Z"
							fill="#EC1C24"
						/>
					</svg>
				)}
			</div>
			{/* сначала идет условие будет ли удаленный поиск или нет */}
			{isEmpty(remote)
				/* если не удаленный поиск, идет проверка на существование опций, тип инпута и флага на отображение пустого списка */
				? options && type === "input" && !emptyOptions
						/* если флаг установлен в false и есть длина у листа опций, активен флаг показа выподающего списка и есть ссылка на инпут */
						? !!renderList!.length &&
							active &&
							ref.current && (
								<DropSelect maxHeight={264} zIndex={100} widthTarget={true} position={"center"}
										target={ref.current}>
									{/* если флаг загрузки активен показывать индикатор загрузки, иначе список */}
								{load ? (
									<Load className={sass.load} width={16} height={16}/>
								) : (
									<>
										{!emptySearch&&
											<SearchList
												created={isCreated}
												lastTarget={lastSearchTarget}
												list={searchedList}
												debounced={isEmpty(remote) ? value : debounced}
											/>
										}

										{renderList}
										<div ref={lastTarget}/>
									</>
								)}
							</DropSelect>
						)
						/* если флаг установлен в true и есть ссылка на инпут */
						: active &&
							ref.current && (
								<DropSelect maxHeight={264} zIndex={100} widthTarget={true} position={"center"}
											target={ref.current}>
									{/* если флаг загрузки активен отображается индикатор загрузки, иначе если есть длина у листа опций, отображать их, иначе показывать отсутствие доступных опций*/}
									{load ? (
										<Load className={sass.load} width={16} height={16}/>
									) : renderList!.length ? (
										<>
											{!emptySearch&&
												<SearchList
													created={isCreated}
													lastTarget={lastSearchTarget}
													list={searchedList}
													debounced={isEmpty(remote) ? value : debounced}
												/>
											}

											{renderList}
											<div ref={lastTarget}/>
										</>
									) : (
										<div className={sass.empty}>
											<Empty className={sass.svg} width={"10%"}/>
											<p>Нет данных</p>
										</div>
									)}
								</DropSelect>
							)
				/* если удаленный поиск, идет проверка на на флаг отображения выподающего списка, тогда показывать лист */
				: active && (
					<DropSelect maxHeight={264} zIndex={100} widthTarget={true} position={"center"} target={ref.current}>
						{(type !== "select" && !emptySearch) && (
							<SearchList
								lastTarget={lastSearchTarget}
								created={isCreated}
								list={searchedList}
								debounced={isEmpty(remote) ? value : debounced}
							/>
						)}
						{renderList}
						<div ref={lastTarget}/>
					</DropSelect>
			)}
		</>
	);
};

const SearchList: React.FC<{ lastTarget: any; list: any[]; debounced?: string; created: boolean }> = ({
	debounced = "",
	lastTarget,
	created,
	list,
}) => {
	return debounced ? (
		list.length ? (
			<>
				{list}
				<hr ref={lastTarget} />
			</>
		) : (
			<>
				<div className={sass.empty_search}>
					{/*<div>*/}
					<Empty className={sass.svg} width={50} height={50} />
					{/*</div>*/}
					<p>Совпадений не найдено</p>
					{created && <p>Вы можете сохранить введённое значение</p>}
				</div>
				<hr />
			</>
		)
	) : null;
};

export default InputTemp;
